import React, { useEffect, useState } from "react";
import { Prompt, useHistory } from 'react-router-dom';
import { app, teamsCore } from "@microsoft/teams-js";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from "@mui/material";

function useIsInTeams() {
	const [inTeams, setInTeams] = useState(false);

	useEffect(() => {
		app.initialize()
			.then(() => setInTeams(true))
			.catch(() => setInTeams(false));
	}, []);

	return inTeams;
}

export const FormPrompt = ({ hasUnsavedChanges, formPromptTitle, formPromptMessage, formPromptCancel, formPromptOk, currentPathContext, onDiscard }) => {
	const [promptActive, setPromptActive] = useState(true);
	const [currentPath] = useState(currentPathContext);
	const inTeams = useIsInTeams();
	const [showModal, setShowModal] = useState(false);
	const [nextPath, setNextPath] = useState(null);
	const history = useHistory();


	useEffect(() => {
		if (!inTeams) {
			const onBeforeUnload = (e) => {
				if (hasUnsavedChanges) {
					e.preventDefault();
					e.returnValue = "";
				}
			};
			window.addEventListener("beforeunload", onBeforeUnload);
			return () => window.removeEventListener("beforeunload", onBeforeUnload);
		}

	}, [hasUnsavedChanges]);

	useEffect(() => {
		if (inTeams) {
			teamsCore.registerBeforeUnloadHandler(() => {
				return !hasUnsavedChanges; // false blocks leaving
			});
		}
	}, [hasUnsavedChanges, inTeams]);

	const handlePrompt = (location) => {
		if (!promptActive) return true;
		if (!hasUnsavedChanges || location.pathname === currentPath) return true;

		// Store attempted path and show modal
		setNextPath(location.pathname);
		setShowModal(true);

		return false; // block navigation temporarily
	};

	const handleDiscard = () => {
		setPromptActive(false);
		setShowModal(false);
		const pathToNavigate = nextPath;
		setNextPath(null);
		const doNavigate = () => {
			if (pathToNavigate) {
				setTimeout(() => history.push(pathToNavigate), 0);
			}
		};
		if (onDiscard) {
			Promise.resolve(onDiscard()).then(doNavigate);
		} else {
			doNavigate();
		}
	};

	const handleCancel = () => {
		setShowModal(false);
		setNextPath(null);
	};

	return (
		<>
			{/* React Router internal route guard */}
			<Prompt when={hasUnsavedChanges} message={handlePrompt} />

			{/* Teams modal for unsaved changes */}
			<Dialog open={showModal} onClose={handleCancel}>
				<DialogTitle>{formPromptTitle}</DialogTitle>
				<DialogContent>
					<DialogContentText>{formPromptMessage}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancel} sx={{
						backgroundColor: '#FAFAF7',
						color: '#0F0F0F',
						'&:hover': {
							backgroundColor: '#CBCBCB',
						},
					}}>
						{formPromptCancel}
					</Button>
					<Button onClick={handleDiscard} sx={{
						backgroundColor: '#73D266',
						color: '#fff',
						'&:hover': {
							backgroundColor: '#5cbc55',
						},
					}}>
						{formPromptOk}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};